/* tslint:disable */
/* eslint-disable */
/**
 * Veritable
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 7.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CustomAttributeEntityType } from '../models';
// @ts-ignore
import type { CustomAttributeValueResponse } from '../models';
// @ts-ignore
import type { PutCustomAttributeValueRequest } from '../models';
/**
 * CustomAttributeValuesApi - axios parameter creator
 * @export
 */
export const CustomAttributeValuesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get custom attribute values for an entity
         * @param {CustomAttributeEntityType} entityType 
         * @param {string} entityId 
         * @param {Array<string>} [attributeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityCustomAttributeValues: async (entityType: CustomAttributeEntityType, entityId: string, attributeId?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityType' is not null or undefined
            assertParamExists('getEntityCustomAttributeValues', 'entityType', entityType)
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('getEntityCustomAttributeValues', 'entityId', entityId)
            const localVarPath = `/api/v1/customAttributes/value/{entityType}/{entityId}`
                .replace(`{${"entityType"}}`, encodeURIComponent(String(entityType)))
                .replace(`{${"entityId"}}`, encodeURIComponent(String(entityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)

            if (attributeId) {
                localVarQueryParameter['attributeId'] = attributeId.join(COLLECTION_FORMATS.csv);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create or update custom attribute values for an entity
         * @param {CustomAttributeEntityType} entityType 
         * @param {string} entityId 
         * @param {Array<PutCustomAttributeValueRequest>} putCustomAttributeValueRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putCustomAttributeValue: async (entityType: CustomAttributeEntityType, entityId: string, putCustomAttributeValueRequest: Array<PutCustomAttributeValueRequest>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityType' is not null or undefined
            assertParamExists('putCustomAttributeValue', 'entityType', entityType)
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('putCustomAttributeValue', 'entityId', entityId)
            // verify required parameter 'putCustomAttributeValueRequest' is not null or undefined
            assertParamExists('putCustomAttributeValue', 'putCustomAttributeValueRequest', putCustomAttributeValueRequest)
            const localVarPath = `/api/v1/customAttributes/value/{entityType}/{entityId}`
                .replace(`{${"entityType"}}`, encodeURIComponent(String(entityType)))
                .replace(`{${"entityId"}}`, encodeURIComponent(String(entityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(putCustomAttributeValueRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CustomAttributeValuesApi - functional programming interface
 * @export
 */
export const CustomAttributeValuesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CustomAttributeValuesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get custom attribute values for an entity
         * @param {CustomAttributeEntityType} entityType 
         * @param {string} entityId 
         * @param {Array<string>} [attributeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityCustomAttributeValues(entityType: CustomAttributeEntityType, entityId: string, attributeId?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CustomAttributeValueResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityCustomAttributeValues(entityType, entityId, attributeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomAttributeValuesApi.getEntityCustomAttributeValues']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create or update custom attribute values for an entity
         * @param {CustomAttributeEntityType} entityType 
         * @param {string} entityId 
         * @param {Array<PutCustomAttributeValueRequest>} putCustomAttributeValueRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putCustomAttributeValue(entityType: CustomAttributeEntityType, entityId: string, putCustomAttributeValueRequest: Array<PutCustomAttributeValueRequest>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putCustomAttributeValue(entityType, entityId, putCustomAttributeValueRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomAttributeValuesApi.putCustomAttributeValue']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CustomAttributeValuesApi - factory interface
 * @export
 */
export const CustomAttributeValuesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CustomAttributeValuesApiFp(configuration)
    return {
        /**
         * 
         * @summary Get custom attribute values for an entity
         * @param {CustomAttributeValuesApiGetEntityCustomAttributeValuesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityCustomAttributeValues(requestParameters: CustomAttributeValuesApiGetEntityCustomAttributeValuesRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<CustomAttributeValueResponse>> {
            return localVarFp.getEntityCustomAttributeValues(requestParameters.entityType, requestParameters.entityId, requestParameters.attributeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create or update custom attribute values for an entity
         * @param {CustomAttributeValuesApiPutCustomAttributeValueRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putCustomAttributeValue(requestParameters: CustomAttributeValuesApiPutCustomAttributeValueRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.putCustomAttributeValue(requestParameters.entityType, requestParameters.entityId, requestParameters.putCustomAttributeValueRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CustomAttributeValuesApi - interface
 * @export
 * @interface CustomAttributeValuesApi
 */
export interface CustomAttributeValuesApiInterface {
    /**
     * 
     * @summary Get custom attribute values for an entity
     * @param {CustomAttributeValuesApiGetEntityCustomAttributeValuesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomAttributeValuesApiInterface
     */
    getEntityCustomAttributeValues(requestParameters: CustomAttributeValuesApiGetEntityCustomAttributeValuesRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<CustomAttributeValueResponse>>;

    /**
     * 
     * @summary Create or update custom attribute values for an entity
     * @param {CustomAttributeValuesApiPutCustomAttributeValueRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomAttributeValuesApiInterface
     */
    putCustomAttributeValue(requestParameters: CustomAttributeValuesApiPutCustomAttributeValueRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * Request parameters for getEntityCustomAttributeValues operation in CustomAttributeValuesApi.
 * @export
 * @interface CustomAttributeValuesApiGetEntityCustomAttributeValuesRequest
 */
export interface CustomAttributeValuesApiGetEntityCustomAttributeValuesRequest {
    /**
     * 
     * @type {CustomAttributeEntityType}
     * @memberof CustomAttributeValuesApiGetEntityCustomAttributeValues
     */
    readonly entityType: CustomAttributeEntityType

    /**
     * 
     * @type {string}
     * @memberof CustomAttributeValuesApiGetEntityCustomAttributeValues
     */
    readonly entityId: string

    /**
     * 
     * @type {Array<string>}
     * @memberof CustomAttributeValuesApiGetEntityCustomAttributeValues
     */
    readonly attributeId?: Array<string>
}

/**
 * Request parameters for putCustomAttributeValue operation in CustomAttributeValuesApi.
 * @export
 * @interface CustomAttributeValuesApiPutCustomAttributeValueRequest
 */
export interface CustomAttributeValuesApiPutCustomAttributeValueRequest {
    /**
     * 
     * @type {CustomAttributeEntityType}
     * @memberof CustomAttributeValuesApiPutCustomAttributeValue
     */
    readonly entityType: CustomAttributeEntityType

    /**
     * 
     * @type {string}
     * @memberof CustomAttributeValuesApiPutCustomAttributeValue
     */
    readonly entityId: string

    /**
     * 
     * @type {Array<PutCustomAttributeValueRequest>}
     * @memberof CustomAttributeValuesApiPutCustomAttributeValue
     */
    readonly putCustomAttributeValueRequest: Array<PutCustomAttributeValueRequest>
}

/**
 * CustomAttributeValuesApi - object-oriented interface
 * @export
 * @class CustomAttributeValuesApi
 * @extends {BaseAPI}
 */
export class CustomAttributeValuesApi extends BaseAPI implements CustomAttributeValuesApiInterface {
    /**
     * 
     * @summary Get custom attribute values for an entity
     * @param {CustomAttributeValuesApiGetEntityCustomAttributeValuesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomAttributeValuesApi
     */
    public getEntityCustomAttributeValues(requestParameters: CustomAttributeValuesApiGetEntityCustomAttributeValuesRequest, options?: RawAxiosRequestConfig) {
        return CustomAttributeValuesApiFp(this.configuration).getEntityCustomAttributeValues(requestParameters.entityType, requestParameters.entityId, requestParameters.attributeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create or update custom attribute values for an entity
     * @param {CustomAttributeValuesApiPutCustomAttributeValueRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomAttributeValuesApi
     */
    public putCustomAttributeValue(requestParameters: CustomAttributeValuesApiPutCustomAttributeValueRequest, options?: RawAxiosRequestConfig) {
        return CustomAttributeValuesApiFp(this.configuration).putCustomAttributeValue(requestParameters.entityType, requestParameters.entityId, requestParameters.putCustomAttributeValueRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

